import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { sess_get, sess_put } from 'utils/HttpRequests';
import PreLoader from 'components/Others/PreLoader';
import Input from './Input';

export default function RewardDetails(props) {
  const [flightDetails, setFlightDetails] = useState({});
  const [edit, setEdit] = useState(false);
  const [statusList, setStatusList] = useState([]);
  const [status, setStatus] = useState('');
  const [budget, setBudget] = useState(0);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [priority, setPriority] = useState(0);
  const [notification, setNotification] = useState('');
  const [notificationList, setNotificationList] = useState([]);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchRewardsDetails();
    sess_get('admin/console/flight-statuses-list', localStorage.getItem('admin-panel-sessionToken'))
      .then((res) => {
        setStatusList(res?.data?.response?.availableStatuses);
      })
      .catch((err) => {
        console.log('err', err.response.data);
      });

    sess_get('admin/console/template/push', localStorage.getItem('admin-panel-sessionToken'))
      .then((res) => { setNotificationList(res?.data?.response); })
      .catch((err) => { console.log('err'); });
  }, [props.id]);

  const fetchRewardsDetails = () => {
    setLoading(true);
    const { id } = props;
    sess_get(`admin/console/flight-details?flightId=${id}`, localStorage.getItem('admin-panel-sessionToken'))
      .then((res) => {
        console.log(res?.data?.response?.flightDetails);
        setFlightDetails(res?.data?.response?.flightDetails);
        setStatus(res?.data?.response?.flightDetails?.status);
        setStartDate(res?.data?.response?.flightDetails?.start_date?.split('T')[0]);
        setEndDate(res?.data?.response?.flightDetails?.end_date?.split('T')[0]);
        setPriority(res?.data?.response?.flightDetails?.priority);
        setNotification(res?.data?.response?.flightDetails?.pn_template);
        setLoading(false);
      })
      .catch((err) => { console.log(err); setLoading(false); });
  };

  const editReward = () => {
    setLoading(true);
    const data = {};
    if (flightDetails?.end_date?.split('T')[0] !== endDate) data.end_date = endDate;
    if (flightDetails?.start_date?.split('T')[0] !== startDate) data.start_date = startDate;
    if (flightDetails?.pn_template !== notification) data.pn_template = notification;
    if (flightDetails?.priority !== priority) data.priority = priority;
    if (flightDetails?.status !== status) data.status = status;
    if (budget !== 0) data.budget = budget;

    sess_put(`admin/console/update-flight-details?flightId=${props.id}`, localStorage.getItem('admin-panel-sessionToken'), data)
      .then((res) => {
        setEdit(false);
        setError('');
        fetchRewardsDetails();
        setLoading(false);
      })
      .catch((err) => { setError(err?.response?.data?.error?.reason); setLoading(false); });
  };

  return (
    <div style={{ width: '80%', margin: '40px auto' }}>
      {loading && <PreLoader />}
      <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
        <div>

          <h2 style={{ margin: '0' }}>Rewards Details</h2>

          <p style={{ fontSize: '18px' }}>
            Flight_id : {props.id}
          </p>
        </div>

        <button className="btn btn-primary" style={{ height: '40px' }} disabled={edit} onClick={() => setEdit(true)}>Edit</button>
      </div>
      <div style={{
        display: 'flex', flexDirection: 'row', margin: '20px auto', padding: '10px', border: '1px solid black', borderRadius: '8px',
      }}
      >

        <table>
          <tr>
            <th>Name</th>
            <td>{flightDetails.name}</td>
          </tr>
          <tr>
            <th>Description</th>
            <td>{flightDetails.description}</td>
          </tr>
          <tr>
            <th>Method</th>
            <td>{flightDetails.method}</td>
          </tr>
          <tr>
            <th>User type</th>
            <td>{flightDetails.user_type}</td>
          </tr>

          <tr>
            <th>Created At</th>
            <td>
              {moment(flightDetails?.created_at).format('DD-MM-YYYY HH:mm')}
            </td>
          </tr>
          <tr>
            <th>Start Date</th>
            <td>
              {
                edit
                  ? <Input type="date" defaultValue={startDate} id="startDate" value={startDate} min={new Date().toISOString().split('T')[0]} setValue={(val) => setStartDate(val)} />
                  : moment(flightDetails.start_date).format('DD-MM-YYYY HH:mm')
              }
            </td>
          </tr>
          <tr>
            <th>End Date</th>
            <td>
              {
                edit

                  ? <Input type="date" defaultValue={endDate} id="endDate" value={endDate} min={startDate || new Date().toISOString().split('T')[0]} setValue={(val) => setEndDate(val)} />
                  : moment(flightDetails.end_date).format('DD-MM-YYYY HH:mm')
              }
            </td>
          </tr>
        </table>
        <table>
          {
            edit
              ? (
                <tr>
                  <th>Add Budget</th>
                  <td><Input value={budget} type="number" setValue={(val) => setBudget(val)} /></td>
                </tr>
              )
              : null
          }
          <tr>
            <th>Allotted Budget</th>
            <td>{flightDetails.allotted_budget}</td>
          </tr>
          <tr>
            <th>Remaining Budget</th>
            <td>{flightDetails.remaining_budget}</td>
          </tr>
          <tr>
            <th>Avail Count</th>
            <td>{flightDetails.avail_count}</td>
          </tr>
          <tr>
            <th>Priority</th>
            <td>
              {
                edit
                  ? <Input type="number" min={0} defaultValue={priority} id="priority" value={priority} setValue={(val) => setPriority(val)} />
                  : flightDetails.priority
              }
            </td>
          </tr>
          <tr>
            <th>Status</th>
            <td>
              {
                edit
                  ? <Input type="select" options={statusList} value={status} defaultValue={status} setValue={(val) => setStatus(val)} />
                  : flightDetails.status
              }

            </td>
          </tr>
          <tr>
            <th>Notification</th>
            <td>
              {
                edit
                  ? <Input type="notification" options={notificationList} value={notification} defaultValue={flightDetails?.pn_template} setValue={(val) => setNotification(val)} />
                  : flightDetails.pn_template
              }

            </td>
          </tr>
        </table>

        {flightDetails?.trusted_services?.length > 0
          ? (
            <table>
              <tr><th>Trusted Services</th></tr>
              {flightDetails.trusted_services.map((item) => (
                <tr><td>{item}</td></tr>
              ))}
            </table>
          )
          : null}

      </div>
      <div style={{
        margin: '20px auto', padding: '10px', border: '1px solid black', borderRadius: '8px',
      }}
      >
        <h4>Floor Payout</h4>
        <table>
          <tr>
            <th>Reward Type</th>
            <th>Payout Type</th>
            <th>Min</th>
            <th>Max</th>
          </tr>
          <tr>
            <td>{flightDetails?.floor_payout?.reward_type}</td>
            <td>{flightDetails?.floor_payout?.payout_type}</td>
            <td>{flightDetails?.floor_payout?.min}</td>
            <td>{flightDetails?.floor_payout?.max}</td>
          </tr>
        </table>
      </div>
      {flightDetails?.payout_graph?.length > 0
        ? (
          <div style={{
            margin: '20px auto', padding: '10px', border: '1px solid black', borderRadius: '8px',
          }}
          >
            <h4>Graph Payout</h4>
            <table>
              <tr>
                <th>Level</th>
                <th>Reward Type</th>
                <th>Payout Type</th>
                <th>Min</th>
                <th>Max</th>
              </tr>

              {flightDetails?.payout_graph.map((item) => (

                <tr>
                  <td>{item?.level}</td>
                  <td>{item?.reward_type}</td>
                  <td>{item?.payout_type}</td>
                  <td>{item?.amount?.min || item?.validity?.min}</td>
                  <td>{item?.amount?.max || item?.validity?.max}</td>
                </tr>
              ))}
            </table>
          </div>
        )
        : null}

      {
        edit
          ? (
            <div style={{ textAlign: 'center' }}>
              <p style={{ color: 'red' }}>{error}</p>
              <button className="btn btn-primary" onClick={() => setEdit(false)}>Cancel</button>
              <button className="btn btn-primary" onClick={editReward}>Save</button>
            </div>
          )
          : null
      }
    </div>
  );
}
